module.exports = __webpack_public_path__ + "static/media/mobile_cloud.6312d134.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Cloud/mobile_cloud.png
// module id = 53
// module chunks = 0